import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/** 工作台图标操作：无描边按钮，图标本身可点；传 to 时渲染为路由 Link */
const WorkbenchIconAction = ({
	icon,
	iconComponent: IconComponent,
	to,
	onClick,
	disabled = false,
	active = false,
	tone = 'default',
	title,
	ariaLabel,
	ariaControls,
	ariaExpanded,
	ariaCurrent,
	className,
	children,
	loading = false,
}) => {
	const mergedClassName = classNames('workbench-icon-action', className, {
		'is-active': active,
		'is-success': tone === 'success',
		'is-danger': tone === 'danger',
	});

	const glyph = (
		<span className='workbench-icon-action__glyph'>
			{loading ? (
				<Spinner animation='border' size='sm' />
			) : IconComponent ? (
				<IconComponent aria-hidden />
			) : (
				<FontAwesomeIcon icon={icon} fixedWidth />
			)}
		</span>
	);

	if (to) {
		return (
			<Link
				to={to}
				className={mergedClassName}
				onClick={disabled || loading ? (event) => event.preventDefault() : onClick}
				aria-disabled={disabled || loading ? true : undefined}
				title={title}
				aria-label={ariaLabel ?? title}
			>
				{glyph}
				{children}
			</Link>
		);
	}

	return (
		<button
			type='button'
			className={mergedClassName}
			onClick={onClick}
			disabled={disabled || loading}
			title={title}
			aria-label={ariaLabel ?? title}
			aria-controls={ariaControls}
			aria-expanded={ariaExpanded}
			aria-current={ariaCurrent}
		>
			{glyph}
			{children}
		</button>
	);
};

WorkbenchIconAction.propTypes = {
	icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	iconComponent: PropTypes.elementType,
	to: PropTypes.string,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	active: PropTypes.bool,
	tone: PropTypes.oneOf(['default', 'success', 'danger']),
	title: PropTypes.string,
	ariaLabel: PropTypes.string,
	ariaControls: PropTypes.string,
	ariaExpanded: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	ariaCurrent: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	className: PropTypes.string,
	children: PropTypes.node,
	loading: PropTypes.bool,
};

export default WorkbenchIconAction;
